module.exports = __webpack_public_path__ + "static/media/happy4.00c4cc02.svg";